import { Component, Input, OnInit, inject } from '@angular/core';
import { Office } from 'app/core/models/office.model';
import { OfficeService } from 'app/core/services/office.service';
import { ProviderOffice } from 'app/core/models/provider-office.model';
import { NotesForModelComponent } from '../../../shared/components/notes-for-model/notes-for-model.component';

import { OfficeProviderNewFormComponent } from '../office-provider-new-form/office-provider-new-form.component';
import { OfficeProviderListComponent } from '../office-provider-list/office-provider-list.component';

@Component({
    selector: 'app-office-detail',
    templateUrl: './office-detail.component.html',
    styleUrls: ['./office-detail.component.scss'],
    imports: [NotesForModelComponent, OfficeProviderNewFormComponent, OfficeProviderListComponent]
})
export class OfficeDetailComponent implements OnInit {
  private officeService = inject(OfficeService);

  @Input() office: Office;

  showAddProviders = false;

  providerOffices: ProviderOffice[];
  providerOfficesLoading = true;

  ngOnInit() {
    this.loadProviderOffices();
  }

  onAddNewProvidersClick() {
    this.showAddProviders = true;
  }

  onProviderFormChanged() {
    this.loadProviderOffices();
  }

  onProviderFormCompleted() {
    this.showAddProviders = false;
  }

  private loadProviderOffices() {
    this.officeService.getProviderOffices(this.office.id).subscribe((providerOffices: ProviderOffice[]) => {
      this.providerOffices = providerOffices;
      this.providerOfficesLoading = false;
    })
  }
}
